import { Box } from '../../primitives';
import { styled } from '../../theme';

export const Separator = styled(Box)`
	width: 100%;
	height: 0;
	border-top: 1px solid ${({ theme }) => theme.color.lightGray.base};
`;
